import React from 'react';
import { Timer as HeaderTimer } from '@pegasus/ui-headers/components/Timer';
import { CartStatusEnum } from '@pegasus/cart/components/expired-overlay';
import { useTimer } from '@pegasus/cart/hooks';
import { Cart } from '@pegasus/cart/types/cart';
import { usePushNotifications } from '@client/helpers/pushNotification/hooks';

export interface Props {
    cart?: Cart;
    setTimerState: (status: CartStatusEnum) => void;
    onExpiredCart: () => void;
}

export const Timer = ({ cart, setTimerState, onExpiredCart }: Props) => {
    const pushNotification = usePushNotifications();
    const { counter } = useTimer(cart, {
        onCartExpiresFirstWarning: () => {
            setTimerState(CartStatusEnum.CART_EXPIRE_IN_5_MINUTES);
            pushNotification(CartStatusEnum.CART_EXPIRE_IN_5_MINUTES);
        },
        onCartExpiresSecondWarning: () => {
            setTimerState(CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD);
            pushNotification(CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD);
        },
        onCartExpiresLastWarning: () => {
            setTimerState(CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD);
        },
        onCartExpired: () => {
            setTimerState(CartStatusEnum.CART_EXPIRED);
            pushNotification(CartStatusEnum.CART_EXPIRED);
            onExpiredCart();
        }
    });

    return <HeaderTimer timeLeft={counter} />;
};
